import Swiper from 'swiper';
import {Navigation, Pagination, Thumbs, Autoplay, Keyboard, Controller} from 'swiper/modules';
Swiper.use([Navigation, Pagination, Thumbs, Autoplay, Keyboard, Controller]);
window.Swiper = Swiper;

/* ------------ Property Images Slider ------------ */
const property_images_slider = new Swiper(".property-images-slider", {
	loop: false,
	slidesPerView: 1,
	spaceBetween: 10,
	pagination: {
		el: ".property-pagination.swiper-pagination",
		clickable: true,
	},
});

$('.properties-nav button[data-toggle="pill"]').on('shown.bs.tab', function (event) {
	property_images_slider.forEach((slider) => {
		slider.update();
		slider.emit('slideChangeTransitionEnd');
	})
})
